import { useMemo } from 'react';

import getBrowseInSearchCollectionsConfig from 'bundles/search-common/components/experiments/browseInSerp/getBrowseInSearchCollectionsConfig';
import {
  DEFAULT_SORTED_VALUE,
  NUMBER_OF_RESULTS_PER_PAGE,
  SEARCH_FILTERS_INDEX_ID,
  SEARCH_MAIN_INDEX_ID,
  SEARCH_SUGGESTIONS_INDEX_ID,
} from 'bundles/search-common/constants';
import { DEFAULT_SEARCH_FILTERS, IS_PART_OF_COURSERA_PLUS } from 'bundles/search-common/constants/filter';
import type { SearchConfig } from 'bundles/search-common/providers/searchTypes';
import { getShouldShowBrowseInSERP, getShouldUseRemoveFilterHack } from 'bundles/search-common/utils/experimentUtils';

export const getSearchConfigs = (showCourseraPlusFilter: boolean): SearchConfig[] => {
  const filterAttributes = showCourseraPlusFilter
    ? [...DEFAULT_SEARCH_FILTERS, IS_PART_OF_COURSERA_PLUS]
    : DEFAULT_SEARCH_FILTERS;

  const browseInSearchCollectionsConfig = getBrowseInSearchCollectionsConfig({ filterAttributes });
  const searchResultConfig: SearchConfig[] = [
    // For Proper filtering keep main search page index as the first index and the search-filters index as the last index
    {
      id: SEARCH_MAIN_INDEX_ID,
      entityType: 'PRODUCTS',
      limit: NUMBER_OF_RESULTS_PER_PAGE,
      facets: filterAttributes,
      syncQueryWithUrl: true,
      syncFiltersWithUrl: true,
      sortBy: DEFAULT_SORTED_VALUE,
    },
    // used at the bottom of the SERP to suggest additional queries
    {
      id: SEARCH_SUGGESTIONS_INDEX_ID,
      entityType: 'SUGGESTIONS',
      limit: 10,
      syncQueryWithUrl: true,
    },
  ];
  const searchFilterConfig: SearchConfig = {
    id: SEARCH_FILTERS_INDEX_ID,
    entityType: 'PRODUCTS',
    limit: NUMBER_OF_RESULTS_PER_PAGE,
    facets: filterAttributes,
    syncQueryWithUrl: true,
    syncFiltersWithUrl: false,
  };
  if (getShouldShowBrowseInSERP() === true) {
    searchResultConfig.push(...browseInSearchCollectionsConfig);
  }
  if (!getShouldUseRemoveFilterHack()) {
    searchResultConfig.push(searchFilterConfig);
  }
  return searchResultConfig;
};

export const useSearchConfigs = (showCourseraPlusFilter: boolean = false): SearchConfig[] => {
  return useMemo(() => getSearchConfigs(showCourseraPlusFilter), [showCourseraPlusFilter]);
};

export default useSearchConfigs;
